import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ClientInterface } from '../data';
import { ContractProvider } from '../providers/contract.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface UpdateFirstHolderUseCaseParams {
    client: ClientInterface;
}

@Injectable()
export class UpdateFirstHolderUseCase implements UseCaseWithParam<UpdateFirstHolderUseCaseParams, Observable<Transaction<void>>> {
    constructor(private contractProvider: ContractProvider) {}

    bind(params: UpdateFirstHolderUseCaseParams): Observable<Transaction<void>> {
        return this.contractProvider.current().pipe(
            map((transaction) =>
                transaction.map(
                    (contract) => {
                        contract.holders[0] = params.client;
                        return Transaction.success();
                    },
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
